
export const name = "automation-ui-canvas";
export const version = "dev";
